import classNames from "classnames";
import { isTour } from "lib/predicates";
import { formatCoordinatesDMS, sanitizeHtml, truncate } from "lib/util";

export const DirectionsSection = ({
  item,
  section,
}: {
  item: Travelguide.OOI;
  section: Travelguide.POISection.Directions;
}) => {
  const coordinatesDD = isTour(item) ? item.startingPoint : item.geometry;
  const coordinatesGMS = formatCoordinatesDMS(coordinatesDD);
  return (
    <section className="flex flex-col gap-5 px-4 md:px-6">
      <header>
        <h2>Anreise</h2>
      </header>
      <main
        className={classNames(
          "flex flex-col md:grid md:grid-cols-2 gap-10 gap-y-6",
          "lg:grid-cols-[repeat(auto-fit,minmax(calc(100%/3-(2.5rem*2/3)),1fr))]"
        )}
      >
        <div className="flex flex-col gap-2 max-w-fit">
          <h3>Koordinaten</h3>
          <dl className="grid grid-cols-[auto,1fr] gap-x-6">
            <dt>DD</dt>
            <dd className="justify-self-end">
              {truncate(String(coordinatesDD.lat), 11)},{" "}
              {truncate(String(coordinatesDD.lng), 11)}
            </dd>
            <dt>GMS</dt>
            <dd className="justify-self-end">
              {coordinatesGMS.lat}, {coordinatesGMS.lng}
            </dd>
          </dl>
          <p>
            <a
              href={`/travelguide/download/gpx/${item.id}`}
              className="whitespace-nowrap"
            >
              GPX herunterladen
            </a>{" "}
            |{" "}
            <a
              href={`/travelguide/download/kml/${item.id}`}
              className="whitespace-nowrap"
            >
              KML herunterladen
            </a>
          </p>
        </div>
        {section.value.gettingThere && (
          <div className="flex flex-col gap-2">
            <h3>Anfahrt</h3>
            {sanitizeHtml(section.value.gettingThere)}
          </div>
        )}
        {section.value.publicTransit && (
          <div className="flex flex-col gap-2">
            <h3>Öffentliche Verkehrsmittel</h3>
            {sanitizeHtml(section.value.publicTransit)}
          </div>
        )}
        {section.value.parking && (
          <div className="flex flex-col gap-2">
            <h3>Parken</h3>
            {sanitizeHtml(section.value.parking)}
          </div>
        )}
      </main>
    </section>
  );
};
